import { isGeneratedArtifactUserMessage } from '@/utils/generatedArtifactAssistantPayload'

/** @param {string} trimmed */
export function pendingAgentMeta(trimmed) {
  if (
    trimmed.toLowerCase() === 'response component' ||
    isGeneratedArtifactUserMessage(trimmed)
  ) {
    return {
      agentBrand: 'SIA',
      agentName: 'Master Root Agent',
      thoughtSummary: 'Thinking…',
    }
  }
  return {}
}
